const getEventName = (element: HTMLElement): string => {
    return element?.dataset?.trackingEvent || "unkown event name";
};

const elementHasBeenTracked = (element: HTMLElement): boolean => {
    return element?.dataset?.trackingDone === "true";
};

const setElementHasBeenTracked = (element: HTMLElement): void => {
    if (element && element.dataset) element.dataset.trackingDone = "true";
};

const getJsonPayload = (element?: HTMLElement, attribute?: string): any => {
    const dataAttribute = attribute || "trackingInfo";
    const payload = element?.dataset[dataAttribute] || "{}";
    try {
        return JSON.parse(payload) || {};
    } catch (e) {
        console.warn("hubo: unable to parse tracking payload");
    }

    return {};
};

const hasTrackingEventSuffix = (element: HTMLElement, suffix: string) => {
    return (
        element.dataset.trackingEvent &&
        element.dataset.trackingEvent.endsWith(suffix)
    );
};

const findClosestContext = (element: HTMLElement) => {
    const closest = element.closest(
        "[data-tracking-event='section-impression']",
    ) as HTMLElement;

    if (closest) {
        return getJsonPayload(closest, "trackingInfo");
    }
};

export {
    getJsonPayload,
    getEventName,
    elementHasBeenTracked,
    setElementHasBeenTracked,
    findClosestContext,
    hasTrackingEventSuffix,
};
